module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download-wrapper"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('img', {
    attrs: {
      "src": "https://img3.doubanio.com/f/talion/7837f29dd7deab9416274ae374a59bc17b5f33c6/pics/card/douban-app-logo.png",
      "alt": "",
      "width": "48px",
      "height": "48px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info-title"
  }, [_c('strong', [_vm._v("豆瓣")]), _vm._v(" "), _c('span', [_vm._v("我们的精神角落")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("免费下载 Android 客户端")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0258c3a1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/download/download.vue
// module id = 53
// module chunks = 1